import { Link } from 'react-router-dom';

const COMPANY = {
  name: 'Eleven Group EDT SLU',
  cif: 'B55230940',
  address: 'Carrer Onyar 65, 17457 Riudellots de la Selva (Girona)',
  email: 'info@ecommsystem.net',
  web: 'sera.ecommsystem.net',
};

export default function LegalPage() {
  return (
    <LegalLayout title="Aviso Legal" active="legal">
      <section>
        <h2>1. Datos identificativos del titular</h2>
        <p>En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa de los datos del titular del sitio web:</p>
        <table>
          <tbody>
            <tr><td>Razón social</td><td>{COMPANY.name}</td></tr>
            <tr><td>CIF</td><td>{COMPANY.cif}</td></tr>
            <tr><td>Domicilio social</td><td>{COMPANY.address}</td></tr>
            <tr><td>Correo electrónico</td><td><a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></td></tr>
            <tr><td>Sitio web</td><td>{COMPANY.web}</td></tr>
          </tbody>
        </table>
      </section>

      <section>
        <h2>2. Objeto</h2>
        <p>El presente Aviso Legal regula el acceso y uso del sitio web <strong>sera.ecommsystem.net</strong> (en adelante, «el Sitio»), titularidad de {COMPANY.name} (en adelante, «la Empresa»).</p>
        <p>El acceso y uso del Sitio implica la aceptación plena y sin reservas de las condiciones establecidas en este Aviso Legal. Si el Usuario no está de acuerdo con estas condiciones, deberá abstenerse de utilizar el Sitio.</p>
      </section>

      <section>
        <h2>3. Condiciones de uso</h2>
        <p>El Usuario se compromete a utilizar el Sitio y los servicios ofrecidos de conformidad con la ley, el presente Aviso Legal y las buenas costumbres. Queda expresamente prohibido:</p>
        <ul>
          <li>Utilizar el Sitio con fines ilícitos o contrarios a las presentes condiciones.</li>
          <li>Reproducir, distribuir o modificar los contenidos sin autorización expresa de la Empresa.</li>
          <li>Introducir o difundir virus informáticos o código malicioso.</li>
          <li>Realizar acciones que provoquen una carga desproporcionada en la infraestructura del Sitio.</li>
          <li>Intentar acceder sin autorización a áreas restringidas del sistema.</li>
        </ul>
      </section>

      <section>
        <h2>4. Propiedad intelectual e industrial</h2>
        <p>Todos los contenidos del Sitio —incluyendo, sin carácter limitativo, textos, imágenes, gráficos, logotipos, iconos, código fuente y software— son propiedad de {COMPANY.name} o de sus licenciantes, y están protegidos por la legislación española e internacional sobre propiedad intelectual e industrial.</p>
        <p>Queda prohibida la reproducción total o parcial, distribución, comunicación pública o transformación de dichos contenidos sin la autorización previa y por escrito de la Empresa.</p>
      </section>

      <section>
        <h2>5. Responsabilidad</h2>
        <p>La Empresa no garantiza la disponibilidad continua e ininterrumpida del Sitio y no se responsabiliza de los daños que puedan derivarse de interrupciones, errores técnicos o accesos no autorizados ajenos a su voluntad.</p>
        <p>La Empresa no se hace responsable de los contenidos de sitios web de terceros enlazados desde el Sitio. La inclusión de enlaces externos no implica aprobación ni recomendación de dichos sitios.</p>
      </section>

      <section>
        <h2>6. Legislación aplicable y jurisdicción</h2>
        <p>El presente Aviso Legal se rige por la legislación española. Para la resolución de cualquier controversia derivada del acceso o uso del Sitio, las partes se someten a los juzgados y tribunales del domicilio del Usuario, de acuerdo con la legislación aplicable en materia de protección de consumidores, o a los del domicilio de la Empresa cuando se trate de relaciones entre empresas.</p>
      </section>

      <section>
        <h2>7. Modificaciones</h2>
        <p>La Empresa se reserva el derecho a modificar el presente Aviso Legal en cualquier momento. Las modificaciones serán efectivas desde su publicación en el Sitio. Se recomienda al Usuario revisarlo periódicamente.</p>
        <p><em>Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}</em></p>
      </section>
    </LegalLayout>
  );
}

function LegalLayout({ title, active, children }) {
  const links = [
    { to: '/legal', label: 'Aviso Legal', key: 'legal' },
    { to: '/privacidad', label: 'Privacidad', key: 'privacidad' },
    { to: '/cookies', label: 'Cookies', key: 'cookies' },
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#09090b', color: '#e4e4e7', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      {/* Header */}
      <header style={{ borderBottom: '1px solid #27272a', padding: '16px 0' }}>
        <div style={{ maxWidth: 860, margin: '0 auto', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
          <Link to="/" style={{ color: '#a78bfa', fontWeight: 700, fontSize: 18, textDecoration: 'none', letterSpacing: '-0.01em' }}>
            Sera AI
          </Link>
          <nav style={{ display: 'flex', gap: 4 }}>
            {links.map(l => (
              <Link
                key={l.key}
                to={l.to}
                style={{
                  padding: '6px 14px',
                  borderRadius: 6,
                  fontSize: 13,
                  fontWeight: 500,
                  textDecoration: 'none',
                  background: active === l.key ? '#27272a' : 'transparent',
                  color: active === l.key ? '#f4f4f5' : '#a1a1aa',
                  transition: 'background 0.15s, color 0.15s',
                }}
              >
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
      </header>

      {/* Content */}
      <main style={{ maxWidth: 860, margin: '0 auto', padding: '48px 24px 96px' }}>
        <h1 style={{ fontSize: 32, fontWeight: 700, color: '#f4f4f5', marginBottom: 8, letterSpacing: '-0.02em' }}>{title}</h1>
        <p style={{ fontSize: 13, color: '#71717a', marginBottom: 48 }}>
          {COMPANY.name} · CIF {COMPANY.cif} · <a href={`mailto:${COMPANY.email}`} style={{ color: '#a78bfa', textDecoration: 'none' }}>{COMPANY.email}</a>
        </p>
        <style>{`
          main section { margin-bottom: 40px; }
          main h2 { font-size: 17px; font-weight: 600; color: #f4f4f5; margin: 0 0 12px; padding-bottom: 8px; border-bottom: 1px solid #27272a; }
          main p { font-size: 14px; line-height: 1.75; color: #a1a1aa; margin: 0 0 12px; }
          main ul, main ol { padding-left: 20px; margin: 0 0 12px; }
          main li { font-size: 14px; line-height: 1.75; color: #a1a1aa; margin-bottom: 4px; }
          main a { color: #a78bfa; text-decoration: underline; }
          main strong { color: #d4d4d8; }
          main em { color: #71717a; }
          main table { width: 100%; border-collapse: collapse; margin: 16px 0; }
          main td { font-size: 14px; padding: 10px 14px; border: 1px solid #27272a; color: #a1a1aa; vertical-align: top; }
          main td:first-child { color: #d4d4d8; font-weight: 500; white-space: nowrap; width: 180px; }
        `}</style>
        {children}
      </main>

      {/* Footer */}
      <footer style={{ borderTop: '1px solid #27272a', padding: '24px', textAlign: 'center' }}>
        <p style={{ fontSize: 12, color: '#52525b', margin: 0 }}>
          © {new Date().getFullYear()} {COMPANY.name} · {COMPANY.cif} ·{' '}
          <Link to="/legal" style={{ color: '#71717a', textDecoration: 'none' }}>Aviso Legal</Link>
          {' · '}
          <Link to="/privacidad" style={{ color: '#71717a', textDecoration: 'none' }}>Privacidad</Link>
          {' · '}
          <Link to="/cookies" style={{ color: '#71717a', textDecoration: 'none' }}>Cookies</Link>
        </p>
      </footer>
    </div>
  );
}

export { LegalLayout, COMPANY };
